// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Styles
const Container = styled.div`
  color: ${colors.coral};
  display: inline;
  margin: ${(props) => props.margin};

  & > svg {
    height: ${(props) => props.height};
    width: ${(props) => props.width};
  }
`;

// Component
const VisaSvg = ({ height, margin, width }) => (
  <Container height={height} margin={margin} width={width}>
    <svg
      width="42px"
      height="25px"
      viewBox="0 0 42 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g
        id="Checkout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Checkout_USA" transform="translate(-20.000000, -517.000000)">
          <g id="Visa-dark" transform="translate(20.000000, 517.000000)">
            <rect
              id="Rectangle"
              fill="#26337A"
              x="-1.77990955e-12"
              y="0"
              width="41.627907"
              height="25"
              rx="4"
            />
            <polyline
              id="Fill-3"
              fill="#FFFFFE"
              points="17.2714148 16.4778169 18.5513636 8.53028169 20.5973157 8.53028169 19.3174839 16.4778169 17.2714148 16.4778169"
            />
            <path
              d="M26.7387998,8.72535211 C26.3342667,8.56584507 25.6980369,8.39190141 24.9054703,8.39190141 C22.8826878,8.39190141 21.4588062,9.47042254 21.4469873,11.0147887 C21.4341153,12.1571596 22.4630593,12.7942488 23.2387752,13.1739437 C24.0360225,13.5631455 24.303878,13.8122066 24.3007185,14.1602113 C24.2952186,14.6924883 23.6643717,14.936385 23.0761195,14.936385 C22.2569897,14.936385 21.8217977,14.8163146 21.1489411,14.5196009 L20.8857664,14.3930751 L20.5996561,16.1720657 C21.0767407,16.3934272 21.9611668,16.5855634 22.8790602,16.5956573 C25.0288078,16.5956573 26.4256582,15.5301643 26.4420408,13.8809859 C26.4494129,12.9751174 25.9042235,12.2884977 24.7235065,11.7215962 C24.0085232,11.3530516 23.5697037,11.1089202 23.5747355,10.7359155 C23.5752035,10.4056338 23.9454502,10.0519953 24.7467932,10.0519953 C25.4160222,10.0411972 25.900479,10.195892 26.2779808,10.3573944 L26.4616999,10.4482394 L26.7387998,8.72535211"
              id="Fill-4"
              fill="#FFFFFE"
            />
            <path
              d="M29.4631084,13.6600939 C29.6326683,13.2032864 30.2781425,11.438615 30.2781425,11.438615 C30.2662067,11.4596244 30.4467663,10.9782864 30.5500936,10.6803991 L30.6881755,11.3658451 C30.6881755,11.3658451 31.0807727,13.2627934 31.1616325,13.6600939 L29.4631084,13.6600939 L29.4631084,13.6600939 Z M31.9871983,8.53838028 L30.4060438,8.53838028 C29.9156191,8.53838028 29.5485319,8.67899061 29.3336859,9.1971831 L26.2952995,16.4806338 L28.444228,16.4806338 C28.444228,16.4806338 28.7948155,15.5008216 28.8743881,15.2857981 C29.1087763,15.2857981 31.1968551,15.2899061 31.4949013,15.2899061 C31.556219,15.5672535 31.7440338,16.4806338 31.7440338,16.4806338 L33.6430107,16.4806338 L31.9871983,8.53838028 L31.9871983,8.53838028 Z"
              id="Fill-5"
              fill="#FFFFFE"
            />
            <path
              d="M15.5549868,8.53697183 L13.5524485,13.9552817 L13.3379536,12.8538732 C12.9647814,11.5848592 11.8031384,10.2093897 10.5037645,9.52018779 L12.3358068,16.470892 L14.5011178,16.4696009 L17.7231063,8.53697183 L15.5549868,8.53697183"
              id="Fill-6"
              fill="#FFFFFE"
            />
            <path
              d="M11.693492,8.53157277 L8.39415426,8.53157277 L8.36700596,8.69624413 C10.9342757,9.35457746 12.6329168,10.943662 13.3379536,12.8538732 L12.620981,9.20211268 C12.4972924,8.69847418 12.1378114,8.5491784 11.693492,8.53157277"
              id="Fill-7"
              fill="#EC982D"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
);
VisaSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default VisaSvg;
